export default {
  getProductPurchasePrice: (state) => state.productPurchasePrice,
};
